<script lang="ts">
export default {
  name: 'KkInsightPolling',
}
</script>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
<template>
  <div>
    <h2 class="c-pageTitle">
      {{ t('pages.companies.analysis.insight.polling.title') }}
    </h2>
    <p>{{ t('pages.companies.analysis.insight.polling.notice') }}</p>
  </div>
</template>
<style lang="scss" scoped>
</style>
